import { productService, promotionService } from './firebaseService';
import { orderService } from './orderService';
import { blogService } from './blogService';

export const adminService = {
  getProducts: async (page = 0, size = 100) => {
    try {
      const products = await productService.getAllProducts(size);
      return Array.isArray(products) ? products : [];
    } catch (error) {
      console.error('Error fetching admin products:', error);
      throw error;
    }
  },
  deleteProduct: async (id) => productService.deleteProduct(id),
  createProduct: async (payload) => productService.createProduct(payload),
  updateProduct: async (id, payload) => productService.updateProduct(id, payload),
  updateProductStock: async (id, stockQuantity) => productService.updateProductStock(id, stockQuantity),

  getPromotions: async (page = 0, size = 100) => {
    try {
      const promotions = await promotionService.getAllPromotions(size);
      return Array.isArray(promotions) ? promotions : [];
    } catch (error) {
      console.error('Error fetching admin promotions:', error);
      throw error;
    }
  },
  deletePromotion: async (id) => promotionService.deletePromotion(id),
  createPromotion: async (payload) => promotionService.createPromotion(payload),
  updatePromotion: async (id, payload) => promotionService.updatePromotion(id, payload),
  updatePromotionStock: async (id, stockQuantity) => promotionService.updatePromotionStock(id, stockQuantity),

  getOrders: async () => {
    try {
      const orders = await orderService.getAllOrders();
      return Array.isArray(orders) ? orders : [];
    } catch (error) {
      console.error('Error fetching admin orders:', error);
      throw error;
    }
  },
  deleteOrder: async (id) => orderService.deleteOrder(id),

  // Blog
  getBlogPosts: async () => {
    try {
      const posts = await blogService.getAllPosts();
      return Array.isArray(posts) ? posts : [];
    } catch (error) {
      console.error('Error fetching admin blog posts:', error);
      throw error;
    }
  },
  getBlogPost: async (id) => blogService.getPostById(id),
  isBlogSlugTaken: async (slug, excludeId) => blogService.isSlugTaken(slug, excludeId),
  createBlogPost: async (payload) => blogService.createPost(payload),
  updateBlogPost: async (id, payload) => blogService.updatePost(id, payload),
  deleteBlogPost: async (id) => blogService.deletePost(id),
  getBlogCategories: async () => blogService.getCategories(),
  createBlogCategory: async (name) => blogService.createCategory(name),
  deleteBlogCategory: async (id) => blogService.deleteCategory(id),
  getBlogTags: async () => blogService.getTags()
};